'use client'

type Props = {
  date: Date
}
const DateToLocaleString = ({ date }: Props) => {
  return (
    <p>{date.toLocaleString()}</p>
  )
}

export default DateToLocaleString